export const info_jobs=(id)=>`/v2/guest/opportunities/get/${id}`
